import { render, staticRenderFns } from "./ApplicationUpdate.vue?vue&type=template&id=bef5bf46"
import script from "./ApplicationUpdate.vue?vue&type=script&lang=js"
export * from "./ApplicationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports